"use client";

import { Flex } from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { EmptyState } from "@/components/feedback";
import { Button, Link, NavLink, Text } from "@/components/ui";
import { PageTypeGlobal, PageTypePortal } from "@/lib/types";
import { useThemeTokens } from "@/lib/theme/tokens";

interface ClassSinglePageErrorProps {
  isInDashboard?: boolean;
  onRetry: () => void;
  isRetrying?: boolean;
}

export const ClassSinglePageError = ({
  isInDashboard = false,
  onRetry,
  isRetrying = false,
}: ClassSinglePageErrorProps) => {
  const theme = useThemeTokens();
  const backHref = isInDashboard
    ? PageTypePortal.ClassRegistration
    : PageTypeGlobal.Classes;

  return (
    <EmptyState
      title="Couldn't load this class"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            Something went wrong while fetching class details. Please try again.
          </Text>
          <Flex gap={3} wrap="wrap" justify="center">
            <Button
              variant="primary"
              size="sm"
              data-testid="class-single-retry-button"
              onClick={onRetry}
              isLoading={isRetrying}
              isDisabled={isRetrying}
            >
              Try again
            </Button>
            <Link
              as={NavLink}
              fontSize="sm"
              fontWeight="500"
              color={theme.accent.primary}
              href={backHref}
              display="inline-flex"
              alignItems="center"
              gap={1}
            >
              <FiArrowLeft />
              Back to classes
            </Link>
          </Flex>
        </Flex>
      }
    />
  );
};

interface ClassSinglePageNotFoundProps {
  isInDashboard?: boolean;
}

export const ClassSinglePageNotFound = ({
  isInDashboard = false,
}: ClassSinglePageNotFoundProps) => {
  const theme = useThemeTokens();
  const backHref = isInDashboard
    ? PageTypePortal.ClassRegistration
    : PageTypeGlobal.Classes;

  return (
    <EmptyState
      title="Class not found"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            The requested class could not be found or is no longer available.
          </Text>
          <Link
            as={NavLink}
            fontSize="sm"
            fontWeight="500"
            color={theme.accent.primary}
            href={backHref}
            display="inline-flex"
            alignItems="center"
            gap={1}
          >
            <FiArrowLeft />
            Back to classes
          </Link>
        </Flex>
      }
    />
  );
};
